/* Размеры шапки из вёрстки: слот 0 — десктоп, слот 1 — мобила до 1023px. */
export const SPECIAL_PROJECT_FEED_HEADER_DESKTOP_WIDTH = 300;
export const SPECIAL_PROJECT_FEED_HEADER_MOBILE_WIDTH = 768;
